import { Component, OnInit } from '@angular/core';
import { Router, ActivatedRoute,RouterModule } from '@angular/router';

@Component({
  selector: 'app-home',
  templateUrl: './home.component.html',
  styleUrls: ['./home.component.scss']
})
export class HomeComponent implements OnInit {

  constructor(private router: Router) { }

  ngOnInit() {
    this.router.navigate(['/login']);
  }

}



// WEBPACK FOOTER //
// ./src/app/home/home.component.ts